// @ts-nocheck

import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Document from '../components/Document/Document';
import SunbitApi from '../services/SunbitApi';
import DocumentTypes from '@sunbit-dev/common/enums/DocumentTypes';
import qs from 'qs';
import { datadogRum } from '@datadog/browser-rum';

enum DocumentError {
  ErrorLoading = 'ErrorLoading',
  NotFound = 'NotFound',
}

interface IDocumentContainerProps {}

interface IDocumentContainerState {
  documentType: string;
  retailerId: string;
  content: string;
  error?: DocumentError;
}

class DocumentContainer extends React.Component<IDocumentContainerProps & RouteComponentProps, IDocumentContainerState> {
  public state: IDocumentContainerState = {
    documentType: '',
    retailerId: '',
    content: '',
  };

  public async componentDidMount() {
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    try {
      const documentData = await SunbitApi.getDocument(DocumentTypes[params.documentType], params.retailerId);
      this.setState({
        documentType: params.documentType,
        retailerId: params.retailerId,
        content: documentData.content,
      });
      datadogRum.addAction(`page-view: document-${params.documentType}`, {});
    } catch (e) {
      datadogRum.addAction(`error: document`, { error_info: { type: DocumentError.ErrorLoading, ...e } });
      this.setState({
        ...this.state,
        error: DocumentError.ErrorLoading,
      });
    }
  }

  public render() {
    return (
      <>
        <Document loadDocument={() => {}} content={this.state.content} error={this.state.error} />
      </>
    );
  }
}

export default withRouter(DocumentContainer);
